<template>
  <div>
    <el-dialog :title="form.isCreate ? '新增渠道' : '修改渠道'" center :visible="true" @close="onClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="840px">
      <el-form ref="form" :model="form" label-width="160px" size="mini">
        <el-form-item label="ID：">
          <el-input :disabled="!form.isCreate" v-model="form.channel.id" style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item label="名称：">
          <el-input v-model="form.channel.name" style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item label="主sdk：">
          <el-input v-model="form.channel.mainSdk" style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item label="主sdk的参数：">
          <el-input type="textarea" rows="5" v-model="form.channel.mainSdkParams" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="采用测试支付金额：">
          <el-switch v-model="form.channel.isUseTestPayAmount" active-color="#13ce66"></el-switch>
        </el-form-item>
        <el-form-item label="测试支付金额（分）：" v-if="form.channel.isUseTestPayAmount">
          <el-input v-model="form.channel.testPayAmount" style="width: 170px"></el-input>
        </el-form-item>
        <el-form-item label="独立支付方式的参数：">
          <el-input type="textarea" rows="5" v-model="form.channel.payWays" style="width: 600px"></el-input>
        </el-form-item>
        <el-form-item label="额外属性：">
          <el-input type="textarea" rows="5" v-model="form.channel.extra" style="width: 600px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");

// 本弹窗名称
const DialogName = "EditChannelConfigDialog";

export default {
  data() {
    return {
      form: {
        isCreate: true,
        action: "add",
        channel: {
          testPayAmount: 100,
        },
      },
    };
  },
  components: {

  },

  async created() {
    let value = this.$dialogutil.getData(DialogName);

    this.form.isCreate = value.isCreate;

    if (!this.form.isCreate) {
      this.form.channel = value.oldData
      this.form.channel.mainSdkParams = this.string2FormatCode(value.oldData.mainSdkParams)
      this.form.channel.isUseTestPayAmount = !!value.oldData.isUseTestPayAmount
      this.form.channel.testPayAmount = value.oldData.testPayAmount > 0 ? value.oldData.testPayAmount : 100
      this.form.channel.payWays = this.string2FormatCode(value.oldData.payWays)
      this.form.channel.extra = this.string2FormatCode(value.oldData.extra)
    }
  },

  methods: {
    string2FormatCode(str){
        try {
          let obj = JSON.parse(str)
          return JSON.stringify(obj, null, "    ")
        } catch (e) {
          return str
        }
    },
    /**
     * 提交表单
     */
    async submit() {
      let id = Number(this.form.channel.id)
        if (isNaN(id) || id != parseInt(this.form.channel.id) || id < 1) {
          this.$message.error("ID必须是一个大于0的数字");
          return
        }

        if(!this.form.channel.name||this.form.channel.name.trim().length < 1){
          this.$message.error("名称不能为空");
          return
        }

        if(!this.form.channel.mainSdk||this.form.channel.mainSdk.trim().length < 1){
          this.$message.error("主sdk不能为空");
          return
        }
      try {
        if (this.form.isCreate) {
          // 弹确认框
          await this.$confirm(
            `确认新增渠道：${this.form.channel.name}`,
            {
              type: 'warning',
            }
          );

          this.form.action = "add"
          await this.callApi()
        } else {
          // 弹确认框
          await this.$confirm(
            `确认修改渠道：${this.form.channel.name}`,
            {
              type: 'warning',
            }
          );

          this.form.action = "update"
          await this.callApi()
        }
      } catch (e) { }
    },

    async callApi() {
      try {
        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/manageChannels`,
            this.form,
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        this.onClose()
      } catch (e) { }
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>